//首页
//1.导航栏
export const navItems = [
  { title: '首页', details: [] },
  { title: '关于CIMDR', details: [] },
  { title: 'CIMDR2021', details: [] },
 
  { title: '新闻动态', details: [] },
  // { title: 'CIMDR独家记忆', details: [] },
  { title: '资料下载', details: [] },
  { title: '往期回顾', details: ['2016CIMDR', '2017CIMDR', '2018CIMDR', '2019CIMDR','2020CIMDR'] },
  { title: '联系我们', details: [] },
  // { title: '平行会议', details: [] },
  // { title: '疫情防控须知', details: [] },
]
//2.0
export const AboutCimdr = '关于CIMDR'
export const review = '往期回顾'
export const Review = '往期回顾'
export const ReviewDetail = ['2016CIMDR', '2017CIMDR', '2018CIMDR', '2019CIMDR']
export const News = '新闻动态'
export const Download = '资料下载'
export const More = '更多'
export const ContactUs = '联系我们'
//3.0 登录完成后
export const loginDeclare = '登录说明'
export const signUp = '我要报名'
export const logout = '退出'
//4.登录
export const login = {
  title: '第十一届',
  detail: '中国医疗器械监督管理国际会议',
  phoneHolder: '请输入手机号/邮箱',
  pwdHolder: '请输入密码',
  register: '用户注册',
  forgetPwd: '忘记密码',
  login: '登录'
};

//3.0 子导航
// export const navItemsChild=[
//   {title:'首页',details:[]},
//   {title:'新闻动态',details:['筹备会']},
//   {title:'会议信息',details:['基本信息','会议安排','交通信息','酒店信息']},
//   {title:'会议日程',details:[]},
//   {title:'联系我们',details:[]},
//   {title:'注册须知',details:[]},
//   {title:'资料下载',details:[]}
// ];

export const navItemsChild = [
  { title: '首页', details: [] },
  { title: '新闻动态', details: [] },
  { title: '会议信息', details: [{ id: 1432, name: '基本信息' }, { id: 1433, name: '会议安排' }, { id: 1434, name: '交通信息' }, { id: 1235, name: '酒店信息' }] },
  { title: '会议日程', details: [] },
  { title: '联系我们', details: [] },
  { title: '注册须知', details: [] },
  { title: '资料下载', details: [] },
  // { title: '直播', details: [{ id: 101, name: '大会直播' }, { id: 102, name: '平行会议直播' }] }
 
];

export const ForumInformation = '会议日程'
export const Agenda = '注册须知'
export const Registration = '资料下载'

export const MeetingIng_Info_id = "1000"//筹备会
export const BaseInfo_Info_id = "1432"//会议基本信息
export const MeetingManage_Info_id = "1433"//会议安排
export const TrainInfo_Info_id = "1434"//交通信息
export const HotelInfo_Info_id = "982"//酒店信息
// 注册须知
export const Registration_Info_id = "1438"

// 联系我们ID
export const Contact_info_Id = '1436'
// 关于CIMDR
export const About_info_id = '1431'


//会议日期
export const ForumDateTitleFirst = '第十二届'
export const ForumDateTitleSecond = '中国医疗器械监督管理国际会议'
export const ForumDate = [
  { title: '会议日期', detail: '2021年09月23日-26日' },
  { title: '网上注册优惠截止日期', detail: '2021年08月20日' },
  { title: '网上注册截止日期', detail: '2021年09月26日' },
  { title: '现场注册时间', detail: '2021年09月23日' }
];

//HomeFoot
export const footer = {
  public: '国家药品监督管理局 (NMPA) 中国食品药品国际交流中心(CCFDIE)版权所有',
  address: '中国北京市西直门北大街32号枫蓝国际中心B座写字楼11层1106室',
  telAndPostcodeAndFax: '电话:010-82212866 邮编:100082 传真:010-82212857',
  tel: '010-82212866',
  code: '100082',
  fax: '010-82212857',
  web: '网站:',
  record: '京ICP备15042885号-1',
  technicalSupport: '医点通提供技术支持',
  keyaddress: '地址：',
  keyphone: '电话：',
  keyfax: '传真：',
  keyWebsite: '网址：',
  keyzipcode: '邮编：',
}

//新闻动态 为空／文字显示
export const noInfo = '暂无信息，敬请期待！'


export const noOpen = '暂未开放！'

export const accessFailed = '访问失败,请稍后重试！'

export const AccountOrPwdError = '账号／密码错误'

export const AccountNotRegister = '账号未注册，请注册后再登录！'

export const correntPhoneAdnPhone = '请输入正确的手机号／邮箱！'

export const lessPwd = '密码不能少于6位'

export const phoneAndEmailNon = '手机号／邮箱不能为空'

export const pwdNon = '密码不能为空'

//register注册
export const userRegister = '用户注册'
export const backHome = '返回首页'

export const EmailTitle = 'Email'
export const TelPhoneTitle = '手机'
export const PWD = '密码'
export const ConfirmPWD = '确认密码'
export const Name = '姓名'
export const NameFirst = '姓的拼音'
export const NameLast = '名的拼音'
export const Sex = '性别'
export const SexBoys = '男'
export const SexGirls = '女'
export const Provice = '省直辖市'
export const city = '市／县'
export const Unit = '单位'
export const Position = '行政职务'
export const PhoneAddress = '通讯地址'
export const PostCode = '邮编'
export const Phone = '电话'
export const PhoneFirst = '区号'
export const PhoneNumber = '电话号'

export const enterEmail = '输入email'
export const enterTelPhone = '输入手机号'
export const enterPWD = '输入密码'
export const enterConfirmPWD = '输入密码'
export const enterName = '输入姓名'
export const enterNameFirst = '输入姓'
export const enterNameLast = '输入名'
export const enterUnit = '输入单位'
export const enteProvice = '选择你的省份'
export const enterCity = '选择你的城市'
export const enterPosition = '输入行政职务'
export const enterPhoneAddress = '输入通讯地址'
export const enterPostCode = '输入邮编'
export const enterPhone = '输入电话'
export const enterPhoneFirst = '区号'
export const enterPhoneNumber = '电话号'

export const enterAddress = '地址'
export const regAddress = '输入地址'
export const vericationAddress = '地址不能为空'

export const enterMyphone = '电话'
export const regMyphone = '输入电话'
export const vericationMyphone = '电话不能为空'

export const enterMyEmail = '邮箱'
export const regMyEmail = '输入邮箱'
export const vericationMyEmail1 = '邮箱不能为空'
export const vericationMyEmail2 = '邮箱格式错误'

export const picture = '照片'
export const uploadImage = '点击上传照片'
export const pictureDesc = '照片描述'
export const enterPictureDesc = '输入照片描述'
export const mysubmit = '提交'
export const memory = 'CIMDR独家记忆'

export const amend = '去修改'
export const participation = '参赛'
export const notices = '格式：JPG/JPEG, 大小：1~10M，数量：至多5张'

//忘记密码

export const RegEmail = '邮箱'
export const RegPhoneNumber = '手机号'
export const RegVericationCode = '验证码'
export const RegPassword = '新密码'
export const RegComfirmPassword = '确认密码'
export const RegGetVerficationCode = '获取验证码'
export const RegPhoneFindPWD = '手机号找回密码'
export const RegEmailFindPWD = '邮箱找回密码'
export const enterRegEmail = '输入Email'
export const enterRegPhoneNumber = '输入手机号'
export const enterRegVericationCode = '输入验证码'
export const enterRegPassword = '输入密码'
export const enterRegComfirmPassword = '输入密码'
export const enterFindPWD = '找回密码'
export const getBack = 's后重新获取'



export const vericationNotNull = '验证码不能为空'
export const vericationUnFormat = '电话号格式错误'

export const changePWDSucceed = '修改密码成功'
export const phoneNotRegistered = '手机号还未注册!'
export const vercodeInvalid = '验证码不正确!'
export const emailNotRegistered = '邮箱还未注册'
export const compeletedPerson = '请完善信息'
export const vericationSend = '验证码已发送'
export const findPWDFailture = '找回密码失败'

export const emailNotNull = '邮箱不能为空'
export const emailUnFormat = '不正确的邮箱格式'
export const mobilNotNull = '手机号不能为空'
export const mobilUnFormat = '手机号格式错误'
export const passwordNotNull = '密码不能为空'
export const passwordAtLeastSix = '密码在6-20位数之间'
export const confirmUnFormat = '两次输入的密码不相同'
export const nameNotNull = '姓名不能为空'
export const nameFisrtNotNull = '姓不能为空'
export const nameFisrtUnFormat = '姓格式错误'
export const nameLastNotNull = '名不能为空'
export const nameLastUnFormat = '名格式错误'
export const proviceNotNull = '省直辖市不能为空'
export const cityNotNull = '市／县直辖市不能为空'
export const unitNotNull = '单位不能为空'
export const positionNotNull = '行政职务不能为空'
export const addressNotNull = '通讯地址不能为空'
export const postCodeNotNull = '邮编不能为空'
export const postCodeUnFormat = '邮编格式错误'
export const areaCodeNotNull = '区号不能为空'
export const areaCodeUnFormat = '区号格式错误'
export const phoneNotNull = '电话号不能为空'
export const phoneUnFormat = '电话号格式错误'



export const submit = '提交'

export const congratulation = '恭喜你，注册成功!';
export const haslogin = '您的手机号或邮箱已被注册，请直接登录！';
export const improveInformation = '请完善个人信息！'

//登录说明
export const noteDate = '2021年9月23日-26日'
export const notePlace = '武汉 · 中国光谷科技会展中心'
export const note1 = '1.点击\'用户注册\'填写用户信息，注册成功后您将收到秘书处的账号信息确认邮件'
export const note2 = '2.注册登录之后，点击\'我要报名\'进行会议正式注册报名，在线选择酒店房间预订'
export const note3 = '3.完成线上缴费之后，您将收到秘书处的缴费确认邮件'
export const note4 = '注：请牢记用户名和密码，如需再次登录或修改个人信息，请使用注册时的用户名和密码直接登录查询'

export const notice = '提示'

export const ok = '确定'

export const banner = '../../assets/img/bannerCn.png'

export const locale = 'cn'

export const modulError = '错误'
export const modulWarn = '警告'
export const modulTips = '提示'
export const modulSure = '确定'
export const modulCancel = '取消'

export const modulDel = '确定要删除吗？'
export const modulGolgoin = '请先前往首页登录'
export const modulIpImg = '请上传照片'
export const modulInfo = '请完善信息'
export const modulIUpNum = '图片最多上传5张'

export const modulIUpsize = '图片大小为1~10M，请重新上传'







//////////////////
// WEBPACK FOOTER
// ./static/js/zh.js
// module id = ogb/
// module chunks = 12